export default {
  props: {
    fillColor: {
      type: String,
      default: '#757575'
    },
    hoverFillColor: {
      type: String
    },
    size: {
      type: Number,
      default: 16
    }
  }
}
